import React from 'react'
import { PrismicRichText } from '@prismicio/react'

// @styles
import './styles.scss'

export default function PoliticyTerms({ data }) {
       
    const item = data.nodes[0]?.data?.text?.richText
    return (
        <div className='terms-container'>
            <PrismicRichText field={item} />
        </div>
    );
}